<template>
  <StyledTeamTextButton
    ref="targetEl"
    :disabled="disabled"
    :buttonId="buttonId"
    :suspended="suspended"
    :teamName="isDraw ? drawText : competitor?.name.short"
    :isSelected="isSelected"
  />
</template>

<script lang="ts">
import StyledTeamTextButton from "./styled/TeamTextButton.vue";
import { computed, defineComponent, PropType } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import {
  injectBrand,
  BrandContext
} from "@fresh8/ad-data-composition/src/brand";
import { Option } from "@fresh8/types/src/betData";
import { getTranslation } from "@fresh8/ad-data-composition/src/lang";

export default defineComponent({
  name: "TeamTextButton",
  components: { StyledTeamTextButton },
  props: {
    option: { type: Object as PropType<Option | undefined>, required: true },
    isSelected: { type: Boolean, required: false, default: false },
    isDraw: { type: Boolean },
    competitor: { type: Object, required: false, default: undefined }
  },
  setup(props) {
    const { brand, adTemplate } = injectBrand() || ({} as BrandContext);

    const translations = getTranslation(
      window.navigator.language.toLowerCase()
    );

    const { targetEl } = composePopoverForm("Options Button", [
      {
        type: "button",
        get: () => brand.value?.adTemplate.parlayCard?.teamTextButton || "",
        set: (value: string) => {
          if (brand.value?.adTemplate.parlayCard)
            brand.value.adTemplate.parlayCard.teamTextButton = value;
        }
      }
    ]);

    const buttonId = computed(
      () => adTemplate.value?.parlayCard?.teamTextButton
    );

    const drawText = computed(() => {
      return translations.ParlayTexts.Draw;
    });

    return {
      disabled: !props.option || props.option?.suspended,
      suspended: props.option?.suspended,
      buttonId,
      targetEl,
      drawText
    };
  }
});
</script>
